<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" label-width="110px">

                <el-form-item  label="拥有该权限人">
                    <el-button @click="getMoreUser()">{{form.areaUsersLabel}}</el-button>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 
    import userTransfer from '../../sys/user/UserTransfer.vue';

    export default {
        data(){
            return{
                visible: false,
                transferVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    areaUsers:[],
                    areaUsersLabel: "",
                },
            }
        },
        components: {
            userTransfer
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=data.id;
                this.form.deptId=data.deptId; 

                // 学区教职
                if(data.gateUser!=null){
                    this.form.areaUsers=data.gateUser.split(',');
                    this.form.areaUsersLabel=data.gateUser.split(',').length+"人";
                }else{
                    this.form.areaUsers=[];
                    this.form.areaUsersLabel='请选择';
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.roleUpdateUserUrl;
                        let data = {
                            id:this.form.id,
                            userId:this.form.areaUsers.join(',')
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
                });
            },
            getMoreUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.form.areaUsers.length > 0){
                        this.$refs['userTransfer'].init(2,this.form.areaUsers,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                    }
                }) 
            },
            setUser(key,label){
                this.form.areaUsers = key;
                this.form.areaUsersLabel = key.length+"人";
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/sys/role/SetUser.vue